import { Box, Flex, Image } from '@energiebespaarders/symbols';
import { Heading } from '@energiebespaarders/symbols/helpers';
import { useIsTablet } from '@energiebespaarders/symbols/hooks';
import styled from 'styled-components';
import type { getLongReadOrProductBySlug_allLongReads } from '~/types/generated/cms/getLongReadOrProductBySlug';
import BlockContainer from '../DatoCms/BlockContainer';

interface Props {
  page: Pick<getLongReadOrProductBySlug_allLongReads, 'title' | 'image'>;
}

const StyledImage = styled(Image)<{ $isTablet: boolean }>`
  height: ${x => (x.$isTablet ? '300px' : '500px')};
  width: 100%;
  object-fit: cover;
  border-radius: ${x => (x.$isTablet ? '0px' : '12px')};
`;

const LongReadHero: React.FC<Props> = ({ page }) => {
  const isTablet = useIsTablet();
  return (
    <Flex flexDirection="column">
      <BlockContainer pb={[3, 4, 5]}>
        <Flex flexDirection="column" width={1} justifyContent="center">
          <Box mb={4}>
            <StyledImage
              $isTablet={isTablet}
              src={page.image!.url}
              alt={page.image!.responsiveImage?.alt || ''}
            />
          </Box>

          <Flex width={1} justifyContent="center" textAlign="center">
            <Heading heading="h1" style={{ marginBottom: 0 }}>
              {page.title}
            </Heading>
          </Flex>
        </Flex>
      </BlockContainer>
    </Flex>
  );
};

export default LongReadHero;
